export default [
	'N',
	'NN',
	'NNN',
	'Absolute Net',
	'Ground',
	'Gross',
	'Modified Gross',
	'Vacant',
	'Other',
];